import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import FocusLock from 'react-focus-lock';
import Layer from '../../Layer';
import { StyledModal } from './styled';
import { useModal } from '../../../hooks';
import { ModalProvider } from '../../../contexts/modal';

const Modal = forwardRef((props, ref) => {
  const { closeModal, modalProps, exitProps, nameProps } = useModal(props);

  return createPortal(
    <ModalProvider
      value={{
        closeModal,
        exitProps,
        nameProps,
      }}
    >
      <FocusLock returnFocus autoFocus>
        <Layer isCentered onClose={closeModal}>
          <StyledModal {...modalProps(ref, props)} />
        </Layer>
      </FocusLock>
    </ModalProvider>,
    document.body
  );
});

export default Modal;
